// extracted by mini-css-extract-plugin
module.exports = {"loader":"LoaderLayout_loader__3pa6n"};